import ConfirmModal from "components/confirm-modal";
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import RadioButton from "components/radio-button";
import { ComponentPropsWithoutRef, useState } from "react";
import styles from "./EditSeriesModal.module.scss";

const options = [
  { label: "Only this session", value: "this_session" },
  {
    label: "This and all future sessions",
    value: "this_and_future_session",
  },
  // {
  //   label: "All sessions in the series",
  //   value: "all_sessions",
  // },
];

type Props = Pick<
  ComponentPropsWithoutRef<typeof ModalLayout>,
  "show" | "onHide" | "onConfirm"
>;

const EditSeriesModal = ({ show, onHide, onConfirm }: Props) => {
  const [selectedOption, setSelectedOption] = useState("this_session");

  const [error, setError] = useState<any>();
  const [busy, setBusy] = useState(false);

  const handleHide = () => {
    setError(undefined);
    setBusy(false);
    setSelectedOption("this_session");
    onHide();
  };

  const onOptionChange = (event) => {
    const inputField = event.currentTarget;
    setSelectedOption(inputField.value);
  };

  return (
    <ConfirmModal
      labelTitle={"Edit Recurring Sessions?"}
      children={
        <div>
          <p>
            Would you like to edit only this session, all sessions in the
            series, OR this and all future sessions in the series?
          </p>
          {options.map((option) => (
            <RadioButton
              key={option.value}
              className={styles["edit-series-modal__radio"]}
              id={option.value}
              label={option.label}
              value={option.value}
              name="delete-option"
              onChange={onOptionChange}
              checked={selectedOption === option.value}
            />
          ))}
        </div>
      }
      labelConfirm={"Confirm"}
      hideCancel={true}
      show={show}
      onCancel={() => {
        handleHide();
      }}
      onConfirm={() => onConfirm(selectedOption)}
      disabled={busy}
      error={error}
    />
  );
};

export default EditSeriesModal;
